
import angular from 'angular';
import { DatalayerConstantsType } from 'ib-web-commons/dist/app/core/ib-datalayer/ib-datalayer-constants';
import { DatalayerUtils } from 'src/app/shared/ib-datalayer-utils';



const componentOptions = {
    bindings: {
        model: '=',
        form: '=',
        selectedInsurance: '=',
        countryInsurance: '=',
        conditionsUri: '='
    },
    controllerAs: 'insuranceCtrl',
    templateUrl: ['$rootScope', function ($rootScope) {
        return $rootScope.routes.templates + 'ib-insurance-view.html';
    }]
};


const componentInfo = {
    module: 'ib-insurance-module',
    selector: 'ibInsurance',
    inject: ['$scope', 'localStorageService', '$rootScope', 'DatalayerUtilsService', 'AncillariesConstants', 'DatalayerUtils', 'DatalayerConstants'],
    required: ['']
};
export class ibInsurance implements ng.IController {
    public selectedInsurance;
    public model;
    public form;
    public isClosedTooltip: boolean;
    public showCubaWarning: boolean = false;
    public isAllianzTravelInsuranceLogo:boolean = false;
    constructor (private $scope: angular.IScope,
        private localStorageService: angular.local.storage.ILocalStorageService,
        private $rootScope: CommonsRootScope,
        private DatalayerUtilsService: DatalayerUtilsService,
        private AncillariesConstants: AncillariesConstant,
        private DatalayerUtils: DatalayerUtils,
        private DatalayerConstants: DatalayerConstantsType) {

        this.$scope.$on('deleteInsurance', this.deleteInsurance);
        this.$scope.$on('selectInsuranceControl', this.selectInsuranceControl);
        this.$scope.$on('displayCheckConditions', this.displayCheckConditions);
        this.$rootScope.$on('selectInsuranceDefault', this.selectInsuranceDefault);
        this.$rootScope.$on('initSelectInsurance', this.initSelectInsurance);

    }


    $onInit (): void {
        const status = this.localStorageService.get('selectInsurance');
        let selectedInsurance: any = this.localStorageService.get('insuranceSelected');
        if (this.selectedInsurance) {
            selectedInsurance = this.selectedInsurance;
        }
        if (this.$rootScope.flowName === 'BKI' && this.$rootScope.appMarket === 'ES') {
            const country:any = this.localStorageService.get('headerModel');
            this.showCubaWarning = country.headerModel.trips[0].destinyCode === 'HAV' || country.headerModel.trips[0].originCode === 'HAV';
        }
        if (status) {
            for (let i = 0; i < this.model.length; i++) {
                if (selectedInsurance.id === this.model[i].id) {
                    this.selectedInsurance = this.model[i];
                    this.selectInsuranceControl(true, false);
                }
            }
        }
        this.localStorageService.set('availableInsurances', this.model);
        this.DatalayerUtils.getAncillariesDigitalDataEcommerce('insurance', this.DatalayerConstants.EVENTS_ECOMMERCE.VIEW_ITEM_LIST);
        this.isClosedTooltip = false;
        this.checkIsAllianzTravelInsuranceLogo();
    }

    initSelectInsurance = (evt: any, selectedInsurance: any): any => {
        let i;
        for (i = 0; i < this.model.length; i++) {
            if (selectedInsurance.id === this.model[i].id) {
                this.selectedInsurance = this.model[i];
                this.selectInsuranceControl(true, false);
            }
        }
    };

    /**
     * Delete insurance of model
     * @param {Object} evt Object event
     */
    deleteInsurance = (evt): void => {
        let insuranceLength;
        this.selectedInsurance = null;
        for (insuranceLength = 0; insuranceLength < this.model.length; insuranceLength++) {
            this['checkAcceptConditions_' + insuranceLength] = false;
        }
    };

    /**
     * Emits event with select insurance and save in localStorage state of if is selected or not
     * @param {BOOL} status
     */
    selectInsuranceControl = (status: any, isCountryChanged: any): void => {
        if (!status && this.form) {
            this.form.$submitted = false;
        }
        this.$scope.$emit('selectInsurance', this.selectedInsurance);
        this.localStorageService.set('selectInsurance', status);
        this.localStorageService.set('insuranceSelected', this.selectedInsurance);

        if (this.selectedInsurance && this.selectedInsurance.name) {
            this.DatalayerUtilsService.updateDatalayerActionForAncillaries('seguros', 'clic', 'ko:' + this.selectedInsurance.name);
        } else {
            this.DatalayerUtilsService.updateDatalayerActionForAncillaries('seguros', 'clic', 'ko:' + 'No, ya estoy asegurado');
        }
    };


    /**
     * Open modal of residence country
     */
    openChangeResidenceCountry = (): void => {
        this.$scope.$emit('openChangeResidenceCountry');
    };

    conditionsControl = (consent: any): any => {
        let result = false;
        if (consent) {
            if (consent.length > 5) {
                result = true;
            }
        }
        return result;
    };

    /**
     * Hide Insurance Percentage Tooltip
     * @param {Object} evt
     */
    hideTooltip = (evt): void => {
        this.isClosedTooltip = true;
    };

    /**
     * Select the insurance by clicking on his checkbox or uncheck the checkbox selected on insurance conditions
     * when switch between options and updates the basket with the prices
     * @param  {} index of the selected insurance
     */
    insuranceCheckboxChange = (index: any, isRadioButton: any): void => {
        let insuranceLength;
        for (insuranceLength = 0; insuranceLength < this.model.length; insuranceLength++) {
            if (index !== insuranceLength) {
                this['checkAcceptConditions_' + insuranceLength] = false;
            } else if (!isRadioButton && (this.selectedInsurance !== this.model[index])) {
                this.selectedInsurance = this.model[index];
                this.selectInsuranceControl(true, false);
            } else if (this.selectedInsurance.id === this.model[index].id) {
                if(isRadioButton) this.DatalayerUtils.setInsuranceEcommerce(this.selectedInsurance, this.DatalayerConstants.EVENTS_ECOMMERCE.SELECT_ITEM);
                this.DatalayerUtilsService.updateDatalayerActionForAncillaries('seguros', 'clic', 'ok:' + this.selectedInsurance.name);
            }
        }
    };

    displayCheckConditions = (evt: any, selectedInsurance: any): void => {
        let insuranceLength;
        if (selectedInsurance) {
            this.model.displayCheckConditions = selectedInsurance.id;
        } else {
            this.model.displayCheckConditions = false;
        }
    };

    controlClicking = (): void => {
        this.DatalayerUtilsService.updateDatalayerActionForAncillaries(this.AncillariesConstants.DATALAYER_INFO, this.AncillariesConstants.DATALAYER_INFO.CLICK, this.AncillariesConstants.DATALAYER_INFO.INSURANCE_CONDITIONS);
    };

    /**
     * Open modal of Belguique conditions
     */
    openInsuranceInfoModal = (): void => {
        this.$scope.$emit('openInsuranceInfoModal', this.model[0].compliance.informativeMessage);
    };

    /**
     * Select Insurance Option Cuba Default
     */
    selectInsuranceDefault = (): void => {
        angular.element('[id*=COM025]').click();
        angular.element('html, body').animate({ scrollTop: angular.element('[for*=COM025]').parent().offset().top - 120 });
        this.insuranceCheckboxChange(1, true);
        this.selectInsuranceControl(true, false);
    };

    /**
     * Checks if logo is Allianz or Allianz Travel
    */
    checkIsAllianzTravelInsuranceLogo = (): void => {
        const market = this.$rootScope.appMarket;
        const language = this.$rootScope.appLang;
        switch (market) {
                case 'DK':
                    if (language === 'en') {this.isAllianzTravelInsuranceLogo = true;}
                    break;
                case 'SE':
                    if (language === 'en') {this.isAllianzTravelInsuranceLogo = true;}
                    break;
                case 'DE':
                    if (language === 'de') {this.isAllianzTravelInsuranceLogo = true;}
                    break;
                case 'ES':
                    if (language === 'en' || language === 'es' || language === 'ca') {this.isAllianzTravelInsuranceLogo = true;}
                    break;
                case 'IT':
                    if (language === 'it') {this.isAllianzTravelInsuranceLogo = true;}
                    break;
                default:
                    this.isAllianzTravelInsuranceLogo = false;
        }
    };
}

try {
    const mod = angular.module(componentInfo.module);
    ibInsurance.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibInsurance })
    );
} catch (error) {
    const mod = angular.module(componentInfo.module, componentInfo.required);
    ibInsurance.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibInsurance })
    );
}